import { getSectionTermFilterInfo } from "../../utils/sectionTermUtils";

export const getFilteredDisplaySchedule = ({
  displaySchedule = [],
  currentView,
  sections = [],
  sectionSingletonDoubletonMap = {},
  restrictToAllowedIds = false,
  allowedTeacherIds = [],
  allowedCourseIds = [],
  allowedClassroomIds = [],
  filteredData = [],
  filterIDs = [],
  filtered = false,
  filterOptions = {},
  labsOnlyFiltered = false,
  nonLabsOnlyFiltered = false,
  singletonsFiltered = false,
  doubletonsFiltered = false,
  hasClassroomFiltered = false,
  noClassroomFiltered = false,
}) => {
  if (!Array.isArray(displaySchedule) || displaySchedule.length === 0) return [];

  let filteredDisplaySchedule = [...displaySchedule];

  if (currentView === "teacher" && (restrictToAllowedIds || allowedTeacherIds.length > 0)) {
    filteredDisplaySchedule = filteredDisplaySchedule.filter((entity) =>
      allowedTeacherIds.includes(entity.data_id)
    );
  }

  if (currentView === "course" && (restrictToAllowedIds || allowedCourseIds.length > 0)) {
    filteredDisplaySchedule = filteredDisplaySchedule.filter((entity) =>
      allowedCourseIds.includes(entity.data_id)
    );
  }

  if (currentView === "classroom" && (restrictToAllowedIds || allowedClassroomIds.length > 0)) {
    filteredDisplaySchedule = filteredDisplaySchedule.filter((entity) =>
      allowedClassroomIds.includes(entity.data_id)
    );
  }

  if (Array.isArray(filteredData) && filteredData.length > 0) {
    filteredDisplaySchedule = filteredDisplaySchedule.filter((entity) =>
      filteredData.includes(entity.data_id)
    );
  } else if (filtered) {
    return [];
  }

  if (Array.isArray(filterIDs) && filterIDs.length > 0) {
    filteredDisplaySchedule = filteredDisplaySchedule.filter((entity) =>
      filterIDs.includes(entity.data_id)
    );
  } else if (filterIDs === false) {
    return [];
  }

  const selectedCoursePeriods = (Array.isArray(filterOptions?.periods) ? filterOptions.periods : [])
    .filter(option => option.selected)
    .map(option => `${option.value}`);
  const selectedTerms = (Array.isArray(filterOptions?.terms) ? filterOptions.terms : [])
    .filter(option => option.selected)
    .map(option => `${option.value}`);
  const hasSectionFilters =
    labsOnlyFiltered ||
    nonLabsOnlyFiltered ||
    singletonsFiltered ||
    doubletonsFiltered ||
    hasClassroomFiltered ||
    noClassroomFiltered ||
    selectedCoursePeriods.length > 0 ||
    selectedTerms.length > 0;

  if (hasSectionFilters && ["teacher", "course", "classroom"].includes(currentView)) {
    filteredDisplaySchedule = filteredDisplaySchedule.filter((entity) => {
      const entity_id = `${entity.data_id}`;

      return (Array.isArray(sections) ? sections : []).some((section) => {
        if (!sectionPassesSectionFilters({
          section,
          sectionSingletonDoubletonMap,
          labsOnlyFiltered,
          nonLabsOnlyFiltered,
          singletonsFiltered,
          doubletonsFiltered,
          hasClassroomFiltered,
          noClassroomFiltered,
        })) {
          return false;
        }

        if (currentView === "teacher") {
          const section_teacher_ids = [
            section.teacher_id,
            ...(Array.isArray(section.secondary_teachers) ? section.secondary_teachers : []),
          ].map(teacher_id => `${teacher_id}`);

          return section_teacher_ids.includes(entity_id);
        }

        if (currentView === "course") {
          if (`${section.course_id}` !== entity_id) return false;

          const section_periods = Array.isArray(section.course_periods) ? section.course_periods.map(period_id => `${period_id}`) : [];
          if (selectedCoursePeriods.length > 0) {
            const matches_period = selectedCoursePeriods.some(selected_period => (
              selected_period === "unplaced"
                ? section_periods.length === 0
                : section_periods.includes(selected_period)
            ));
            if (!matches_period) return false;
          }

          if (selectedTerms.length > 0) {
            const section_term_value = `${getSectionTermFilterInfo(section).value}`;
            if (!selectedTerms.includes(section_term_value)) return false;
          }

          return true;
        }

        if (currentView === "classroom") {
          return `${section.classroom_id}` === entity_id;
        }

        return false;
      });
    });
  }

  return filteredDisplaySchedule;
};

export const sectionPassesSectionFilters = ({
  section,
  sectionSingletonDoubletonMap = {},
  labsOnlyFiltered = false,
  nonLabsOnlyFiltered = false,
  singletonsFiltered = false,
  doubletonsFiltered = false,
  hasClassroomFiltered = false,
  noClassroomFiltered = false,
}) => {
  if (!section) return false;

  const singletonDoubletonInfo = sectionSingletonDoubletonMap[section.section_id] || {
    isSingleton: false,
    isDoubleton: false,
  };

  if (labsOnlyFiltered && section.is_lab !== "1") return false;
  if (nonLabsOnlyFiltered && section.is_lab === "1") return false;
  if (singletonsFiltered && !singletonDoubletonInfo.isSingleton) return false;
  if (doubletonsFiltered && !singletonDoubletonInfo.isDoubleton) return false;

  const hasPlacedClassroom =
    Boolean(section.classroom_id) &&
    Array.isArray(section.course_periods) &&
    section.course_periods.length > 0;

  if (hasClassroomFiltered && !hasPlacedClassroom) return false;
  if (noClassroomFiltered && hasPlacedClassroom) return false;

  return true;
};
